import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    expanded: {},

    button: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: theme.spacing(2),
      color: COLORS.gray.medium,
    },
    title: {},
    chevronIcon: {
      fontSize: theme.typography.pxToRem(16),
    },
    collapse: {},
    childrenWrapper: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
  }),
  { name: 'CollapsiblePanel' }
);
